import {handleActions} from 'redux-actions';
import * as type from './actionTypes'
import {List} from './type';
const initState = {
    inputVal:'12222',
    list: [1,2,3,4,5],
    getSendCode: {
        data:{},
        istrue: false
    },
    showModel: {
        show: true,
        msg: ''
    },
    arrList: [],
    carNo:'',
    phoneNo:'',
    isAgreeAuthorization:false,
    isApplyVehicleLicense: false,  //是否上车牌
    districtCode: '',   //投保地区代号
    scrollPosition: 0,        //页面滚动距离
    districtName: '',    //投保地区名称
    pathHistory:1,    //跳转页面,只要不是首页就行,默认是首页为1
}

const actions = {}

actions[type.ChANGE_INPUT] = (state: List, action) => {
  return{
        ...state,
        inputVal: action.payload
        }
}

actions[type.CHANGE_LIST] = (state: List, action) => {
    return{
            ...state,
            list: [...state.list, state.inputVal],
            inputVal: ''
          }
}

actions[type.Del_LIST] = (state: List, action) => {
    let list = state.list;
    list.splice(action.payload ,1);
    console.log(list);
    return {
        ...state,
        list: [...list]
    }
}

actions[type.SEND_STATE] = (state: List, action) => {
    let  getSendCode = {
        data:{...action.payload },
        istrue: !state.getSendCode.istrue
    };
    // console.log('actionsssssssssssssss',getSendCode);
    return {
        ...state,
        getSendCode: getSendCode
    }
}

actions[type.ADDRESS_SELECTSUCESS] = (state, action) => {
    return{
        ...state,
        arrList:action.payload
    }
}
actions[type.ADDRESS_SELECTERROR] = (state, action) => {
    console.log(action);
    return{
        ...state
    }
}

actions[type.SUBMIT_ERROR] = (state, action) => {
    let showModel = {
        show: !state.showModel.show,
        msg: action.payload
    }
    return{
        ...state,
        showModel
    }
}

actions[type.SUBMIT_SUCCESS] = (state, action) => {
	return{
		...state,
        result:action.payload
	}
}

actions[type.SET_CARNO] = (state,action) => {
    return {
        ...state,
        carNo:action.payload,
    }
}

actions[type.SET_PHONENO] = (state,action) => {
    return {
        ...state,
        phoneNo:action.payload,
    }
}

actions[type.SET_AGREE] = (state,action) => {
    return {
        ...state,
        isAgreeAuthorization:action.payload,
    }
}

actions[type.SET_REGISTRATION] = (state,action) => {
    return {
        ...state,
        isApplyVehicleLicense:action.payload,
    }
}

actions[type.SET_DISTRICT] = (state, action) => {
    return {
        ...state,
        districtCode:action.payload,
    }
}

actions[type.SET_SCROLL] = (state, action) => {
    return {
        ...state,
        scrollPosition:action.payload,
    }
}

actions[type.SET_DISNAME] = (state, action) => {
    return {
        ...state,
        districtName:action.payload,
    }
}

actions[type.SET_PATH] = (state, action) => {
    return {
        ...state,
        pathHistory:action.payload,
    }
}

export const productDetail = handleActions(actions, initState)
